"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteAttributeModifier = exports.checkAttributeModifier = exports.addAttributeModifier = exports.createAttributeValue = exports.getAttributeValue = void 0;
function getAttributeValue(prop) {
    let x = prop.value;
    for (const mod of prop.modifiers) {
        if (mod.operation !== 0)
            continue;
        x += mod.amount;
    }
    let y = x;
    for (const mod of prop.modifiers) {
        if (mod.operation !== 1)
            continue;
        y += x * mod.amount;
    }
    for (const mod of prop.modifiers) {
        if (mod.operation !== 2)
            continue;
        y += y * mod.amount;
    }
    return y;
}
exports.getAttributeValue = getAttributeValue;
function createAttributeValue(base) {
    const attributes = {
        value: base,
        modifiers: [],
    };
    return attributes;
}
exports.createAttributeValue = createAttributeValue;
function addAttributeModifier(attributes, modifier) {
    const end = attributes.modifiers.length;
    // add modifer at the end
    attributes.modifiers[end] = modifier;
    return attributes;
}
exports.addAttributeModifier = addAttributeModifier;
function checkAttributeModifier(attributes, uuid) {
    for (const modifier of attributes.modifiers) {
        if (modifier.uuid === uuid)
            return true;
    }
    return false;
}
exports.checkAttributeModifier = checkAttributeModifier;
function deleteAttributeModifier(attributes, uuid) {
    for (const modifier of attributes.modifiers) {
        if (modifier.uuid === uuid)
            attributes.modifiers.splice(attributes.modifiers.indexOf(modifier));
    }
    return attributes;
}
exports.deleteAttributeModifier = deleteAttributeModifier;
